import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import PageHeaderWithActionBar from '@/components/common/Header/PageHeaderWithActionBar.vue'
import PageHeaderWithSearchBar from '@/components/common/Header/PageHeaderWithSearchBar.vue'
import ListContainer from '@board/containers/ListContainer.vue'
import * as types from '@/store/types'
import { mapGetters } from 'vuex'
import api from '@board/api'
@Component({
    components: { PageHeaderWithActionBar, PageHeaderWithSearchBar, ListContainer },
    computed: {
        ...mapGetters({
            currentPage: types.CURRENT_PAGE
        })
    }
})
export default class ListView extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    currentPage!: object
    
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    searchMode: boolean = false
    currentBoard: number = 0
    useNameless: boolean = false

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    getWriteConfig(boardId: number) {
        api.board.getWriteConfig(boardId).then((res: board.WriteConfig) => {
            this.useNameless = res.useNameless
        })
    }

    @Watch('$route.query.id')
    onChangedBoardId(id: string) {
        this.getWriteConfig(Number(id))
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.isloading(true)
        var { id } = this.$route.query

        if (id) this.currentBoard = Number(id)

        this.getWriteConfig(this.currentBoard)
    }
}
